import i18next from '../translations/i18n';

// map text variables to fundData key
const replaceMap = {
  '{FundName}': 'displayName',
  '{ETX}': 'etx',
  '{IndexTR}': 'relatedIndex',
  '{BaseCurrency}': 'baseCCY',
  '{ProductLeverageFactor}': 'LeverageFactor',
  '{ExchangeTradedX}': 'exchangeTradedX',
  '{IndexNameER}': 'IndexNameER',
  '{IndexNameTR}': 'IndexNameTR',
  '{@BaseCurrency}': 'baseCCY',
  '{StrikeTime}': 'StrikeTime',
  '{ProductUnderlyingAsset}': 'productUnderlyingAsset',
  '{IndexNonLevName}': 'indexNameNonLeveraged',
  '{IndexNameNonLev}': 'indexNameNonLeveraged',
  '{ExchangeVenue}': 'ExchangeVenue',
  '{IndexER}': 'indexER',
  '{isSL}': 'isSnL',
  '{ExchangeCode}': 'exchangeCode',
  '{FXFirstCurrency}': 'fxFirstCurrency',
  '{FXBaseCurrency}': 'fxBaseCurrency',
  '{FXFirstCcy}': 'fxFirstCCY',
  '{FXBaseCcy}': 'fxBaseCCY',
  '{FXLongShort}': 'fxLongShort',
  '{isFutureBased}': 'isFutureBased',
  '{fn:Math.abs:ProductLeverageFactor}': 'LeverageFactor',
  '{IndexChange.prevIndexName}': 'prevIndexName',
  '{IndexChange.prevIndexTicker}': 'prevIndexTicker',
  '{IndexChange.newIndexName}': 'newIndexName',
  '{IndexChange.newIndexTicker}': 'newIndexTicker',
  '{IndexChange.dt}': 'indexChangeDate',
};

const formatTextDate = (date, addYear) => {
  const monthNames = i18next.t('months', { returnObjects: true });
  const dt = typeof date === 'string' ? new Date(date) : date;
  const day = dt.getDate();
  if (addYear) {
    return `${day} ${monthNames[dt.getMonth()]} ${dt.getFullYear()}`;
  }

  return `${day} ${monthNames[dt.getMonth()]}`;
};

const getDescendantPropValue = (obj, modelName) => {
  const arr = modelName.split('.');
  let val = obj;
  for (let i = 0; i < arr.length; i += 1) {
    val = val[arr[i]];
  }
  return val;
};

const replaceText = (str, fundData, filters) => {
  const regexText = `(${Object.keys(replaceMap)
    .join('|')
    .replace(/\[/g, '\\[')
    .replace(/\]/g, '\\]')})`;

  let aux = str.replace(new RegExp(regexText, 'g'), x => {
    return fundData[replaceMap[x]];
  });
  // replace date range
  if (filters) {
    aux = aux
      .replace('{StartDate}', formatTextDate(filters.startDate))
      .replace('{EndDate}', formatTextDate(filters.endDate, true));
  }

  // replace if conditions
  const conditionIndex = aux.indexOf('#IF');
  if (conditionIndex >= 0) {
    const condition = aux.slice(conditionIndex, aux.indexOf('#ENDIF') + 6);
    let conditionResult = '';
    const toEval = condition.match(new RegExp(/\(([^)]+)\)/))[1];
    try {
      // eslint-disable-next-line
      if (eval(toEval)) {
        conditionResult = condition.slice(
          condition.indexOf(')') + 1,
          condition.indexOf('#ELSE')
        );
      } else {
        conditionResult = condition.slice(
          condition.indexOf('#ELSE') + 5,
          condition.indexOf('#ENDIF')
        );
      }

      aux =
        aux.substr(0, conditionIndex) +
        conditionResult +
        aux.substr(aux.indexOf('#ENDIF') + 6, aux.length);
    } catch (e) {
      console.error(e);
    }
  }

  return aux;
};

const replaceMarkdownText = (str, fundData) => {
  const regexText = `(${Object.keys(replaceMap)
    .join('|')
    .replace(/\[/g, '\\[')
    .replace(/\]/g, '\\]')})`;

  let aux = str.replace(new RegExp(regexText, 'g'), x => {
    if (x.indexOf('fn:') >= 0) {
      // eval('Math.abs').call(null, -234)
      const fn = x.split(':')[1];
      const value = fundData[replaceMap[x]];
      // eslint-disable-next-line
      return eval(fn).call(null, value);
    }

    if (x.indexOf('IndexChange.dt') >= 0) {
      return formatTextDate(
        getDescendantPropValue(fundData, replaceMap[x]),
        true
      );
    }

    return getDescendantPropValue(fundData, replaceMap[x]);
  });

  // replace if conditions
  const conditionIndex = aux.indexOf('#IF');
  if (conditionIndex >= 0) {
    const condition = aux.slice(conditionIndex, aux.indexOf('#ENDIF') + 6);
    let conditionResult = '';
    // eslint-disable-next-line
    if (eval(condition.match(new RegExp(/\(([^)]+)\)/))[1])) {
      conditionResult = condition.slice(
        condition.indexOf(')') + 1,
        condition.indexOf('#ELSE')
      );
    } else {
      conditionResult = condition.slice(
        condition.indexOf('#ELSE') + 5,
        condition.indexOf('#ENDIF')
      );
    }

    aux =
      aux.substr(0, conditionIndex) +
      conditionResult +
      aux.substr(aux.indexOf('#ENDIF') + 6, aux.length);
  }
  return aux;
};

//NOSONAR
const getCategoryKey = fundData => {
  // IsIndexLeveraged
  if (
    fundData.fundCategoryTier1 === 'Equities' &&
    fundData.LeverageFactor !== 1 &&
    fundData.IsIndexLeveraged === 1
  ) {
    return 'SL_Eq_LevIndex';
  }
  if (
    fundData.fundCategoryTier1 === 'Equities' &&
    fundData.LeverageFactor !== 1 &&
    fundData.isFutureBased !== 1 &&
    fundData.IsIndexLeveraged !== 1
  ) {
    return 'SL_Eq_nLev';
  }

  if (fundData.platform === 'FXL' && fundData.IsIndexLeveraged === 1) {
    return 'FXL_Lev';
  }
  if (fundData.platform === 'FXL' && fundData.IsIndexLeveraged !== 1) {
    return 'FXL_nLev';
  }

  if (
    fundData.isWTMA === 1 &&
    fundData.isSnL !== 1 &&
    fundData.isBasket !== 1
  ) {
    return 'delta1_nTR';
  }

  if (
    fundData.isWTMA === 1 &&
    fundData.isSnL !== 1 &&
    fundData.isBasket === 1
  ) {
    return 'header_delta1_nER_basket';
  }

  if (fundData.isFutureBased === 1 && fundData.isSnL === 1) {
    return 'SL_futureBased';
  }

  if (
    fundData.isFutureBased === 1 &&
    fundData.isSnL !== 1 &&
    fundData.isWTMA !== 1 &&
    fundData.isBasket !== 1
  ) {
    return 'delta1_comm';
  }

  if (
    fundData.isBasket === 1 &&
    fundData.isWTMA !== 1 &&
    fundData.isSnL !== 1
  ) {
    return 'basket_nWTMA';
  }

  return '';
};

const DynamicText = {
  replaceText,
  replaceMarkdownText,
  getCategoryKey,
};

export default DynamicText;
